// When adding experimentation toggle, please make sure the entry in enum matches the feature id/toggle name exactly
export enum ExperimentationToggle {
  //replace with actual toggles when needed
  CWP_EXPERIMENTATION_TOGGLE_PLACEHOLDER = 'CWP_EXPERIMENTATION_TOGGLE_PLACEHOLDER',
}

// Global State
export type ExperimentationState = {
  [key in ExperimentationToggle]: boolean;
};

// Action types
export enum ExperimentationActions {
  UpdateToggle = '[Experimentation] Update Toggle',
}
export interface UpdateExperimentationTogglePayload {
  toggle: ExperimentationToggle;
  value: boolean;
}

export enum ExperimentationSplit {
  POID = 'POID',
  VISITOR_ID = 'VISITOR_ID',
}
